/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * * `CUSTOM_API` - CUSTOM_API
 * * `OPEN_AI_ASSISTANT` - OPEN_AI_ASSISTANT
 * * `AZURE_OPEN_AI_ASSISTANT` - AZURE_OPEN_AI_ASSISTANT
 * * `POE` - POE
 * * `SPITCH` - SPITCH
 * * `AINO` - AINO
 * * `CELINA` - CELINA
 * * `LIVEKIT` - LIVEKIT
 * @export
 */
export const CredentialTypeEnum = {
  customApi: 'CUSTOM_API',
  openAiAssistant: 'OPEN_AI_ASSISTANT',
  azureOpenAiAssistant: 'AZURE_OPEN_AI_ASSISTANT',
  poe: 'POE',
  spitch: 'SPITCH',
  aino: 'AINO',
  celina: 'CELINA',
  livekit: 'LIVEKIT',
} as const;
export type CredentialTypeEnum = (typeof CredentialTypeEnum)[keyof typeof CredentialTypeEnum];

export function instanceOfCredentialTypeEnum(value: any): boolean {
  for (const key in CredentialTypeEnum) {
    if (Object.prototype.hasOwnProperty.call(CredentialTypeEnum, key)) {
      if ((CredentialTypeEnum as Record<string, CredentialTypeEnum>)[key] === value) {
        return true;
      }
    }
  }
  return false;
}

export function CredentialTypeEnumFromJSON(json: any): CredentialTypeEnum {
  return CredentialTypeEnumFromJSONTyped(json, false);
}

export function CredentialTypeEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): CredentialTypeEnum {
  return json as CredentialTypeEnum;
}

export function CredentialTypeEnumToJSON(value?: CredentialTypeEnum | null): any {
  return value as any;
}
